import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.75 15a.75.75 0 0 1-.75.75H3.75A3.754 3.754 0 0 1 0 12V6a3.754 3.754 0 0 1 3.75-3.75H9a.75.75 0 1 1 0 1.5H3.75C2.51 3.75 1.5 4.76 1.5 6v6c0 1.24 1.01 2.25 2.25 2.25H9a.75.75 0 0 1 .75.75M6 12.75a.75.75 0 0 0 .75-.75V6.75h1.5a.75.75 0 1 0 0-1.5h-4.5a.75.75 0 1 0 0 1.5h1.5V12c0 .415.336.75.75.75m7.5 3.75a.75.75 0 0 1-.75-.75V2.25a.75.75 0 0 1 .75-.75.75.75 0 0 0 0-1.5 2.24 2.24 0 0 0-1.5.575A2.24 2.24 0 0 0 10.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75.75.75 0 0 0 0 1.5 2.24 2.24 0 0 0 1.5-.575 2.24 2.24 0 0 0 1.5.575.75.75 0 1 0 0-1.5m1.688-14.132a.75.75 0 1 0-.375 1.453A2.25 2.25 0 0 1 16.501 6v6a2.25 2.25 0 0 1-1.688 2.179.75.75 0 0 0 .374 1.453A3.75 3.75 0 0 0 18 12V6a3.75 3.75 0 0 0-2.812-3.632"
    }, null, -1)
  ]))]))
}
export default { render: render }